"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Container = void 0;
var polished_1 = require("polished");
var styled_components_1 = __importDefault(require("styled-components"));
exports.Container = styled_components_1.default.span(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: inline-block;\n  font-size: ", ";\n  font-weight: bold;\n  letter-spacing: ", ";\n  text-transform: uppercase;\n  margin-bottom: ", ";\n\n  color: ", ";\n"], ["\n  display: inline-block;\n  font-size: ", ";\n  font-weight: bold;\n  letter-spacing: ", ";\n  text-transform: uppercase;\n  margin-bottom: ", ";\n\n  color: ", ";\n"])), (0, polished_1.rem)(14), (0, polished_1.rem)(1.5), (0, polished_1.rem)(16), function (_a) {
    var theme = _a.theme, color = _a.color;
    return color === 'cyan' ? theme.colors.cyan[500] : theme.colors.purple[500];
});
var templateObject_1;
